var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.54,10.21H3a1,1,0,0,0,0,2.08h7.5a1,1,0,1,0,0-2.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,5.62H17.21a1,1,0,0,0,0-2.08H3A1,1,0,1,0,3,5.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87,16.88H3A1,1,0,0,0,3,19H8.87a1,1,0,1,0,0-2.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7,15a1.19,1.19,0,0,0-.72-.3,1,1,0,0,0-.73.3L18.32,17V9.73a1,1,0,0,0-2,0v7.11l-1.65-1.79a1,1,0,0,0-1.51,1.38l3.41,3.7h0a1,1,0,0,0,.73.33h0a1,1,0,0,0,.72-.3l3.7-3.7a1,1,0,0,0,0-1.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.afffafbb00e38ce3bd7129f83995fbf2.svg";
export { ForwardRef as ReactComponent };